import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { AgedPackageStatusComponent } from './aged-package-status/aged-package-status.component';
import { NonUpsBarcodeExtractComponent } from './non-ups-barcode-extract/non-ups-barcode-extract.component';
import { RetailActivityReportComponent } from './retail-activity-report/retail-activity-report.component';

@NgModule({
  declarations: [
    AgedPackageStatusComponent,
    NonUpsBarcodeExtractComponent,
    RetailActivityReportComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OtherModule {}
